import React from "react";

/**
 * SiliconPay PayTech logo — two stacked cards (gold behind, navy in front).
 * variant: "light" (default, navy text) or "dark" (white text for dark bg).
 */
export default function Logo({ variant = "light", className = "" }) {
  const textColor = variant === "dark" ? "#ffffff" : "#0a1f5c";
  const subColor = variant === "dark" ? "#cfd6ee" : "#0a1f5c";

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="sp-logo">
      <svg width="44" height="44" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Yellow card behind */}
        <rect x="22" y="6" width="34" height="50" rx="6" transform="rotate(8 39 31)" fill="#f5b417" />
        {/* Navy card in front */}
        <rect x="8" y="10" width="34" height="50" rx="6" transform="rotate(-8 25 35)" fill="#0a1f5c" />
      </svg>
      <div className="leading-none">
        <div
          className="font-display font-extrabold tracking-tight text-[1.15rem]"
          style={{ color: textColor }}
        >
          SILICONPAY
        </div>
        <div
          className="text-[0.62rem] font-semibold tracking-[0.32em]"
          style={{ color: subColor, opacity: variant === "dark" ? 0.85 : 0.7 }}
        >
          PAY TECH
        </div>
      </div>
    </div>
  );
}
